const STORAGE_KEY = 'customer-portal-root';

export default STORAGE_KEY;
